import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { ComboCliente, ComboNgSelect } from '../../../core/model/combos';
import { DepartamentoSerie } from '../../../core/model/departamento-serie';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { DepartamentosSeriesService } from '../../../core/services/departamentos-series.service';
import { PopulateService } from '../../../core/services/populate.service';
import { SessionService } from '../../../core/services/session.service';
import { ExportacionSeriesService } from '../../../core/services/exportacion-series.service';

@Component({
  selector: 'app-exportacion-expedientes',
  templateUrl: './exportacion-expedientes.component.html',
  styleUrls: ['./exportacion-expedientes.component.css'],
  animations: [
    trigger('slideInOut', [
      state('open', style({
        opacity: 1,
        transform: 'scaleY(1)',
        // padding: '10px',
      })),
      state('close', style({
        opacity: 0,
        transform: 'scaleY(0)',
        // padding: '0px',
      })),
      transition('open => close', animate('300ms ease-in-out')),
      transition('close => open', animate('300ms ease-in-out'))
    ]),
    trigger('hiddenContainer', [
      state('open', style({
        height: '*',
        // padding: '10px'
      })),
      state('close', style({
        height: '0',
        // padding: '0px'
      })),
      transition('open => close', animate('300ms ease-in-out')),
      transition('close => open', animate('300ms ease-in-out'))
    ])
  ]
})
export class ExportacionExpedientesComponent implements OnInit {
  openState = 'open';
  isAdmin: boolean;
  isDocoutUser: boolean;

  cbCliente: ComboCliente[];
  cliente: number = null;

  departamentosSeries = new Map<number, any>();
  cbDepartamentos: ComboNgSelect[] = [];
  departamento: number = null;

  cbSeries: ComboNgSelect[] = [];
  serie: number = null;

  constructor(
    private authService: AuthenticationService,
    private departamentosSeriesService: DepartamentosSeriesService,
    private populateService: PopulateService,
    private sessionService: SessionService,
    public exportacionSerieService: ExportacionSeriesService
  ) { }

  ngOnInit() {
    this.authService.isAdminUserObs().subscribe(admin => {
      this.isAdmin = admin;
    });

    this.authService.isDocOutUser()
      .then((isDocUser: boolean) => {
        this.isDocoutUser = isDocUser;
        if (!this.isDocoutUser) {
          this.getComboDepartamento();
        } else {
          this.getClients();
        }
      });
  }

  private getClients() {
    this.populateService.getComboCliente()
      .pipe(first()).subscribe(
        clientes => {
          this.cbCliente = clientes;
        });
  }

  private getComboDepartamento() {
    this.departamentosSeries.clear();
    this.cbDepartamentos = [];

    if (this.cliente || !this.isDocoutUser) {
      const clienteId = this.isDocoutUser ? this.cliente : this.sessionService.getClientId();

      this.departamentosSeriesService.getDepartamentosSeriesByClient(clienteId)
        .pipe(first()).subscribe((departamentosSeries: DepartamentoSerie[]) => {
          departamentosSeries.forEach((departamentoSerie: DepartamentoSerie) => {
            if (!this.departamentosSeries.has(departamentoSerie.idDepartamento)) {
              this.departamentosSeries.set(departamentoSerie.idDepartamento,
                { nombre: departamentoSerie.nombreDepartamento, series: [] });
              const department = new ComboNgSelect();
              department.ID = departamentoSerie.idDepartamento;
              department.NOMBRE = departamentoSerie.nombreDepartamento;
              this.cbDepartamentos.push(department);
            }
            if (this.departamentosSeries.get(departamentoSerie.idDepartamento).series.filter(serie =>
              serie.idSerie === departamentoSerie.idSerie).length === 0) {
              this.departamentosSeries.get(departamentoSerie.idDepartamento)
                .series.push({ idSerie: departamentoSerie.idSerie, nombreSerie: departamentoSerie.nombreSerie });
            }

          });

          this.cbDepartamentos = [...this.cbDepartamentos];

          if (this.departamentosSeries.size === 1) {
            this.departamento = this.departamentosSeries.keys().next().value;
            this.setSerie();
          }
        });
    }
  }

  private getSeriesCombo(series: any[]): ComboNgSelect[] {
    const comboSeries = [];
    series.map(serie => {
      const serieCombo = new ComboNgSelect();
      serieCombo.ID = serie.idSerie;
      serieCombo.NOMBRE = serie.nombreSerie;
      comboSeries.push(serieCombo);
    });
    this.cbSeries = [...comboSeries];
    return this.cbSeries;
  }

  toggleBody() {
    this.openState = this.openState == 'open' ? 'close' : 'open';
  }

  changeClient() {
    this.departamento = null;
    this.cbDepartamentos = [];
    this.serie = null;
    this.cbSeries = [];

    this.getComboDepartamento();
  }

  setSerie() {
    this.cbSeries = this.departamento ? this.getSeriesCombo(this.departamentosSeries.get(this.departamento).series)
                                      : [];
  }

  exportSerieDocumental() {
    this.exportacionSerieService.exportSerieDocumental(this.serie);
  }

}
